<template>
  <div
    container
    mx-auto
    flex
    flex-col
    w-auto
    divide-y-2
    lg:divide-y-none
    lg:divide-x-2
    divide-stone-200
    p-2
    lg:p-6
    lg:flex-row
  >
    <main flex-grow p-4>
      <Menu />
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </main>
    <aside class="mt-4 lg:mt-0 lg:w-1/3 p-4 lg:px-8 text-stone-600 lg:block">
      <Sidebar :ads="isBot() || isLgScreen" />
    </aside>
  </div>
  <LocationDisabledDialog />
</template>
<script setup>
const route = useRoute();
const config = useRuntimeConfig();
import { useMediaQuery } from "@vueuse/core";

const isLgScreen = useMediaQuery("(min-width: 1024px)");

if (config.public.mockGeolocation && isClient()) {
  console.log("Mocking geolocation");
  useMockGeolocation();
}
useHead({
  bodyAttrs: {
    class: () => `page-${route.name}`,
  },
});
</script>
<style>
@import "@unocss/reset/tailwind.css";
@font-face {
  font-family: "clarendon-text-pro";
  src: url("/fonts/clarendon-text-pro/ClarendonTextPro-Regular.woff2") format("woff2");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "clarendon-text-pro-fallback";
  src: local(georgia);
  ascent-override: 60%;
  descent-override: 0%;
  size-adjust: 109.4%;
}
@font-face {
  font-family: "jetbrains-mono";
  src: url("/fonts/jetbrains-mono/JetBrainsMono-Regular-subset.woff2") format("woff2");
  font-weight: normal;
  font-style: normal;
  unicode-range: U+0-FF, U+131, U+152, U+153, U+2BB, U+2BC, U+2C6, U+2DA, U+2DC, U+2000-206F, U+2074, U+20AC, U+2122,
    U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  font-display: swap;
}
</style>
